<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide" persistent>
    <q-card class="q-dialog-plugin" style="min-width: 300px">
      <q-card-section class="row justify-between items-center">
        <span class="text-h6">Change Password</span>
        <q-btn flat dense icon="close" @click="onCancelClick"></q-btn>
      </q-card-section>
      <q-card-section class="column items-center q-gutter-sm">
        <q-avatar
          size="100px"
          font-size="52px"
          color="grey"
          text-color="white"
          icon="person"
        />
        <div class="row q-gutter-sm items-center">
          <span class="text-bold text-h6">{{ route.meta.user.nama }}</span>
          <q-btn
            flat
            dense
            icon="edit"
            color="primary"
            size="sm"
            @click="dialogName = true"
          ></q-btn>
        </div>
      </q-card-section>
      <q-separator></q-separator>
      <q-card-section class="column q-gutter-sm">
        <div class="column q-gutter-xs">
          <label class="text-bold"> Password Saat Ini :</label>
          <q-input
            outlined
            v-model="setPwd.cur"
            ref="curpwd"
            :type="isPwdCur ? 'password' : 'text'"
            ><template v-slot:append>
              <q-icon
                :name="isPwdCur ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="isPwdCur = !isPwdCur"
              /> </template
          ></q-input>
        </div>
        <div class="column q-gutter-xs">
          <label class="text-bold"> Password Baru :</label>
          <q-input
            outlined
            v-model="setPwd.new"
            :type="isPwdNew ? 'password' : 'text'"
            ref="newpwd"
            ><template v-slot:append>
              <q-icon
                :name="isPwdNew ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="isPwdNew = !isPwdNew"
              /> </template
          ></q-input>
        </div>
        <div class="column q-gutter-xs">
          <label class="text-bold"> Konfirmasi Password Baru :</label>
          <q-input
            outlined
            v-model="setPwd.conf"
            ref="confpwd"
            :type="isPwdConf ? 'password' : 'text'"
            ><template v-slot:append>
              <q-icon
                :name="isPwdConf ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="isPwdConf = !isPwdConf"
              /> </template
          ></q-input>
        </div>
      </q-card-section>
      <q-card-actions align="stretch">
        <q-btn
          no-caps
          unelevated
          class="full-width"
          color="primary"
          label="Simpan"
          @click="waitThis(checkPassword)"
        ></q-btn>
      </q-card-actions>
      <q-dialog v-model="dialogName" persistent>
        <q-card>
          <q-card-section>
            <q-input outlined label="Name" v-model="name"></q-input>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn
              no-caps
              flat
              label="Batal"
              color="primary"
              @click="
                name = curUser.nama;
                dialogName = false;
              "
            ></q-btn>
            <q-btn
              no-caps
              unelevated
              label="Ubah"
              color="primary"
              @click="changeName"
              :disable="name == '' || name == curUser.nama"
            ></q-btn>
          </q-card-actions>
        </q-card>
      </q-dialog>
    </q-card>
  </q-dialog>
</template>

<script>
import { useDialogPluginComponent, useQuasar } from "quasar";
import md5 from "md5";
import useBasic from "@/composables/useBasic";
export default {
  emits: [...useDialogPluginComponent.emits],

  setup() {
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
      useDialogPluginComponent();

    const { waitThis, onMounted, route, $http, ref, $q, parsemd5 } = useBasic();
    let setPwd = ref({
      cur: "",
      new: "",
      conf: "",
    });
    let curUser = ref({});

    let onOKClick = () => {
      onDialogOK();
    };

    onMounted(() => {
      curUser.value = JSON.parse(JSON.stringify(route.meta.user));
      name.value = curUser.value.nama;
    });

    let curpwd = ref(null);
    let newpwd = ref(null);
    let confpwd = ref(null);

    let checkPassword = async () => {
      if (setPwd.value.cur == "") {
        curpwd.value.focus();
        $q.notify({
          message: "Password Saat Ini tidak boleh kosong",
          color: "negative",
        });
        return;
      }
      if (setPwd.value.new == "") {
        newpwd.value.focus();
        $q.notify({
          message: "Password Baru tidak boleh kosong",
          color: "negative",
        });
        return;
      }
      if (setPwd.value.conf != setPwd.value.new) {
        confpwd.value.focus();
        $q.notify({
          message: "Konfirmasi Password tidak sama dengan Password Baru",
          color: "negative",
        });
        return;
      }

      try {
        let payload = {
          username: curUser.value.username,
          password: md5(setPwd.value.cur).toString(),
        };
        let resp = await $http.post("/login", payload);
        if (resp.data) {
          await saveNewPassword();
        }
      } catch (error) {
        $q.notify({ message: "Password Lama Salah", color: "negative" });
        curpwd.value.focus();
      }
    };

    let saveNewPassword = async () => {
      try {
        let payload = {
          id: curUser.value.id,
          password: md5(setPwd.value.new).toString(),
        };
        await $http.post(`/change-password`, payload);
        $q.notify({ message: "Password Berhasil Dirubah", color: "positive" });

        onOKClick();
      } catch (err) {
        $q.notify({ message: "Password Gagal Dirubah", color: "negative" });
      }
    };

    let dialogName = ref(false);
    let name = ref(null);
    let changeName = async () => {
      try {
        $q.loading.show();
        let payload = {
          nama: name.value,
        };

        await $http.put(`/change-name/${curUser.value.id}`, payload);
        dialogName.value = false;
        $q.notify({
          message:
            "Nama Berhasil Dirubah! Silahkan login ulang pada aplikasi untuk memperbaharui nama!",
          color: "positive",
        });
        $q.loading.hide();
      } catch (err) {
        $q.notify({ message: "Nama Gagal Dirubah!", color: "negative" });
        $q.loading.hide();
      }
    };

    return {
      dialogRef,
      onDialogHide,
      onOKClick,
      onCancelClick: onDialogCancel,
      isPwdCur: ref(true),
      isPwdNew: ref(true),
      isPwdConf: ref(true),
      setPwd,
      route,
      checkPassword,
      curpwd,
      newpwd,
      confpwd,
      waitThis,
      dialogName,
      name,
      changeName,
      curUser,
    };
  },
};
</script>
